import React from 'react'
import {ListGroupItem as ListGroupItemBase} from 'reactstrap'
import styled from 'styled-components'
import cn from 'classnames'

const ListGroupItem = styled(ListGroupItemBase)`
  &:hover {
    .fa-circle {
      color: var(--bs-primary) !important;
    }
  }

  .item-option-label {
    &:hover {
      transition: background-color 200ms linear;
      background: var(--bs-gray-200);
    }
  }
`

const ListItemOption = (props) => {
  const {active, onClick, children} = props

  return (
      <ListGroupItem
        onClick={onClick}
        className={cn([
          'p-0',
          'h-100',
          'w-100',
          'd-flex',
          'align-self-center',
          'justify-content-between',
        ])}
        style={{cursor: 'pointer'}}
      >
        <div
          className={cn([
            "d-flex",
            "px-2",
            "border-end"
          ])}
          style={{
            background: active ? 'var(--bs-primary)' : 'var(--bs-white)',
          }}
        >
          <i
            className={cn([              
              "p-2 align-self-center ",
              active ? 'fa fa-dot-circle' : 'far fa-circle',
            ])}
            style={{
              color: active ? "var(--bs-white)" : "var(--bs-gray-700)",
            }}
          />
        </div>
        <div className="item-option-label w-100 px-3 py-3 d-flex flex-column flex-md-row justify-content-between align-self-center">
          {children}
        </div>
      </ListGroupItem>
  )
}

export default ListItemOption
